import HttpService from '../http/http.service';
import { GenericViewModel, NotificationsViewModel } from '@/types/apiServerContract';

const API_PATH = 'notifications/';

export class NotificationApi {
    public static async MarkNotificationAsRead(id: string): Promise<GenericViewModel<boolean>> {
        return HttpService.Get<GenericViewModel<boolean>>(API_PATH + 'MarkNotificationAsRead', {
            id
        });
    }

    public static async MarkAllNotificationsAsRead(): Promise<GenericViewModel<boolean>> {
        return HttpService.Get<GenericViewModel<boolean>>(API_PATH + 'MarkAllNotificationsAsRead');
    }

    public static async GetNotifications(): Promise<NotificationsViewModel> {
        return HttpService.Get<NotificationsViewModel>(API_PATH + 'GetNotifications');
    }
}
